// extracted by mini-css-extract-plugin
export var chevronIcon = "_sg-1";
export var edgeToggle = "_sg-0";